<template>
    <div class="app-wizard-page">
        <div id="apply-area" class="" v-if="!isAdmin">
            <div class="uk-grid" >
                <div class="uk-width-1-1">
                    <div class="uk-vertical-align uk-text-center uk-cover-background uk-animation-fade uk-animation-5 " id="section-top-bg">
                        <div class="uk-vertical-align-middle uk-width-9-10 uk-width-medium-2-3 uk-contrast">
                            <p class="uk-visible-small">&nbsp;</p>
                            <h1 class=" uk-margin-small-top" data-uk-scrollspy="{cls:'uk-animation-fade', delay:500}" >
                                <strong>Section {{currentStep}}:</strong>
                                <span v-if="currentStepObject">{{ currentStepObject.title }}</span>
                            </h1>
                            <div class="uk-progress uk-progress-success uk-progress-striped uk-active">
                                <div class="uk-progress-bar" :style="{width: `${progressPercent}%`}"><span>{{ progressPercent }}%</span></div>
                            </div>
                            <p class="uk-text-small uk-align-center">YOUR PROGRESS</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="uk-container">
            <div class="uk-grid" id="section-nav">
                <div class="uk-width-1-1 uk-margin-small-bottom">
                    <form-wizard
                            ref="wizard"
                            @on-complete="onComplete"
                            @on-change="onStepChange"
                            @on-error="onStepError"
                            title=""
                            subtitle=""
                            color="#589fd2"
                            :activate-all="isAdmin"
                    >
                        <tab-content
                                :title="step.title"
                                v-for="(step, index) in steps"
                                :key="index"
                                :before-change="() => validateStep(index)"
                                icon="uk-icon-dot-circle-o uk-icon-tiny"
                        >
                            <component
                                    :is="step.component"
                                    :ref="step.key"
                                    source="landlord-wizard"
                                    @done="stepUpdated"
                                    @loading="$isLoading"

                            />
                        </tab-content>
                        <template slot="footer" slot-scope="props">
                            <div class="wizard-footer-left">
                                <wizard-button v-if="props.activeTabIndex > 0" @click.native="props.prevTab();" :style="props.fillButtonStyle">Previous</wizard-button>
                            </div>
                            <div class="wizard-footer-right">
                                <wizard-button v-if="!props.isLastStep" @click.native="props.nextTab();" class="wizard-footer-right" :style="props.fillButtonStyle">Save &amp; Continue</wizard-button>
                                <wizard-button v-else @click.native="onComplete" class="wizard-footer-right finish-button" :style="props.fillButtonStyle">{{props.isLastStep ? 'Done' : 'Save &amp; Continue'}}</wizard-button>
                            </div>
                        </template>
                    </form-wizard>
                </div>
            </div>
        </div>

        <modal-dialog title="Are you sure?"
                      ref="confirmSubmitDialog"
                      @confirm="onCompleteModalConfirm">
            Submitting your information will remove your ability to change or update any answers or documents.
            Are you sure you are ready to submit your information?
        </modal-dialog>

        <modal-dialog title="Are you sure?"
                      ref="confirmDeclineDialog"
                      @confirm="onDeclineModalConfirm">
            By clicking OK you are declining to participate in this program.
        </modal-dialog>

    </div>
</template>

<script>
    import {FormWizard, TabContent, WizardButton} from 'vue-form-wizard'
    import 'vue-form-wizard/dist/vue-form-wizard.min.css'
    import Step1 from './Steps/Step1'
    import Step2 from './Steps/Step2'
    import Step3 from './Steps/Step3'
    import ModalDialog from "../../components/Common/ModalDialog";
    import { mapState } from 'vuex';
    import PropertyOwnerManagerInformation from "./Steps/PropertyOwnerManagerInformation";
    import InviteProjectUsers from "../../../dashboard/pages/Projects/Wizard/Steps/InviteProjectUsers";
    import InviteLandlordUsers from "./Steps/InviteLandlordUsers";

    export default {
        name: "LandlordWizard",
        props: ['confirmationId', 'isAdmin'],
        components: {
            ModalDialog,
            FormWizard,
            TabContent,
            WizardButton,
            Step1,
            Step2,
            Step3,
        },
        data() {
            return {
                loading: false,
                currentStep: 1,
                props: {
                    title: '',
                    subtitle: '',
                },
                steps: [
                    {
                        key: 'step1',
                        title: 'Approval',
                        component: Step1
                    },
                    {
                        key: 'step2',
                        title: 'Property and Related Companies',
                        component: PropertyOwnerManagerInformation,
                    },
                    {
                        key: 'step3',
                        title: 'Payment Information',
                        component: Step2
                    },
                    {
                        key: 'step4',
                        title: 'Invite Users',
                        component: InviteLandlordUsers
                    },
                    {
                        key: 'step5',
                        title: 'Confirmation',
                        component: Step3
                    },
                ]
            }
        },
        mounted() {
            this.$isLoading(true);
            this.getData();
            if(this.isAdmin) {
                this.$refs.wizard.activateAll();
            }
        },
        watch: {
            user: {
                deep: true,
                handler(newVal, oldVal) {
                    if (!oldVal && newVal && newVal.application_id)
                        this.fetchApplication(this.user.application_id)
                }
            },
            loading: {
                handler: function(newValue, oldValue) {
                    this.$isLoading(newValue)
                },
            }
        },

        computed: {
            currentStepObject() {
                let currentStepKey = 'step'+this.currentStep;
                for(var i in this.steps) {
                    if(this.steps[i].key == currentStepKey) {
                        return this.steps[i];
                    }
                }
            },

            progressPercent() {
                return Math.ceil(100 / this.steps.length * (this.currentStep-1))
            },

            ...mapState('Landlord', {
                confirmation: 'confirmation',
            })
        },

        methods: {
            setLoading(val)
            {
                this.loading = val
            },

            getData() {
                axios.get('/api/landlord/'+this.confirmationId).then(r => {
                    this.$store.dispatch('App/setUser', { user: r.data.user })
                    this.$store.commit('Application/fetchSuccess', r.data.application)
                    this.$store.commit('Landlord/setConfirmation', r.data.confirmation);
                    this.$store.commit('Landlord/setDocuments', r.data.documents);
                    this.$store.commit('Landlord/setTerms', r.data.terms);
                    this.$store.commit('Landlord/setProjects', r.data.projects);
                    this.$store.commit('Landlord/setRoles', r.data.roles);
                    this.$store.commit('Project/SET_ROLES', r.data.roles);
                    this.$isLoading(false);
                });
            },

            async onComplete() {
                let isValid = await this.validateStep(this.currentStep-1);
                console.log('last valid', isValid);
                if(isValid) {
                    this.$refs.confirmSubmitDialog.open();
                }
            },
            async onCompleteModalConfirm() {
                if(this.isAdmin) {
                    this.$swal({
                        title: 'Thanks!',
                        body: 'This data is complete.',
                    })
                    return;
                }
                window.location = '/'
            },
            onDeclineModalConfirm() {
                axios.post(`/api/landlord/${this.confirmation.id}/decline`).then(r => {
                    if(this.isAdmin) {
                        this.$swal({
                            title: 'Thanks!',
                            body: 'This data is complete.',
                        })
                        return;
                    }
                    window.location = '/landlord/complete'
                })
            },
            scrollTop: function () {
                if (window.pageYOffset > 0) {
                    this.intervalId = setInterval(() => {
                        if (window.pageYOffset === 0) {
                            clearInterval(this.intervalId)
                        }
                        window.scroll(0, window.pageYOffset - 50)
                    }, 5)
                }
            },
            onStepChange(prevIndex, nextIndex) {

                this.currentStep = nextIndex + 1;
                this.scrollTop();
                this.setLoading(false)
            },
            onStepError(error) {
                if (error)
                    this.setLoading(false)
            },
            stepUpdated() {
            },
            async validateStep(index) {
                if(this.currentStep === 1 && this.confirmation.approval === 'declined') {
                    this.$refs.confirmDeclineDialog.open();
                    return false;
                }
                let stepValid = false;
                this.setLoading(true)
                const step = this.steps[index]
                if (this.$refs[step.key] && this.$refs[step.key][0] && this.$refs[step.key][0].validateStep)
                {
                    stepValid = await this.$refs[step.key][0].validateStep();
                } else {
                    stepValid = true;
                }
                this.setLoading(false)
                // this.$store.dispatch('Application/fetch', this.confirmation.household_application_id);
                return stepValid
            }
        }
    }
</script>

<style  lang="scss">
    .uk-progress-bar {
        background-color: #589fd2;
        padding-left: 0px;
        padding-right: 0px;
        & > span {
            padding-left: 10px;
        }
    }
    .agreement-container {
        padding: 20px;

        .agreement-title {
            font-size: 1.3em;
        }

        .uk-block-default {
            background-color: #efefef;
            padding: 20px 20px;
        }
    }

    @media only screen and (max-width: 600px) {
        .vue-form-wizard.md .wizard-icon-circle {
            width: 50px;
            height: 50px;
            font-size: 18px;

        }
        .stepTitle {
            font-size: 12px;
            padding: 2px;
        }

        .wizard-progress-with-circle {
            top: 30px !important;
        }

        .wizard-nav.wizard-nav-pills li {
            width: 25% !important;
        }
    }
</style>
